export type PaymentDepartment = 'parts' | 'service' | 'accounting';

export type PaymentMethod = 'terminal' | 'cardNotPresent' | 'hosted';

export interface CardRefund {
  amount: number;
  id: string;
  invoiceNum: string;
}

export interface CashRefund {
  amount: number;
  id: string;
  invoiceNum: string;
}

export interface Invoice {
  invoiceNum: string;
  amount: number;
  originalInvoiceNum?: string;
  deposit?: boolean;
}

export type CardTransactionResult = 'error' | 'approved' | 'declined' | 'started' | 'unknown' | 'cancelled';

export class CardTransaction {
  amount: number;
  authCode: string;
  cardBin: string;
  cardEntry: string;
  cardExp: string;
  cardLast4: string;
  cardName: string;
  cardToken: string;
  cardType: string;
  extraData: any;
  gateway: 'worldnet-hpp' | 'nmi' | 'payroc';
  id: string;
  receipt: string;
  refId: string;
  refunds: CardRefund[] | null;
  saveCard?: string;
  sessionId: string;
  signatureData: string;
  terminalId: number;
  terminalName: string;
  transactionId: string;
  transactionResponse: string;
  transactionResult: CardTransactionResult;
  transactionType: string;
  userInitials: string;
  username: string;
  voidId: string;
}

export class CashTransaction {
  amount: number;
  id: string;
  refunds: CashRefund[] | null;
  sessionId: string;
  transactionType: string;
  userInitials: string;
  username: string;
}

export interface PaymentSessionEmailEntry {
  address: string;
  date: string;
}

export interface PaymentSession {
  CardTransactions: CardTransaction[];
  CashTransactions: CashTransaction[];
  amount: number;
  branchId: number;
  branchName: string;
  customerName: string;
  customerNum: string;
  customerType: string;
  department: PaymentDepartment;
  id: string;
  invoices: Invoice[];
  mvAccount: string;
  status: string;
  userInitials: string;
  username: string;
  emails?: PaymentSessionEmailEntry[];
}

export interface TransactionSummary {
  address: string;
  amount: number;
  cardBin: string;
  cardEntry: string;
  cardExp: string;
  cardLast4: string;
  cardType: string;
  firstName: string;
  gateway: string;
  hash: string;
  lastName: string;
  terminalName: string;
  token: string;
  transactionId: string;
  transactionResult: CardTransactionResult;
  zip: string;
  saveCard?: string;
  signature: string;
}

export interface PaymentSessionCancelResponse {
  invoices: Invoice[];
  sessionId: string;
}

export interface PaymentSessionSuccessResponse {
  branchName?: string;
  mvAccount?: string;
  cash: number | null;
  customerNum?: string;
  invoices: Invoice[];
  printer?: { id: string; name: string };
  sessionId: string;
  transactions: TransactionSummary[];
}

export interface Customer {
  address: string;
  city: string;
  name: string;
  phone: string;
  state: string;
  type: string;
  zip: string;
  email: string;
}
